import React from "react";
import { Bell } from "lucide-react";
import RushLogo from "../assets/png/rush-logo.png";

const TopNavBar = () => {
  return (
    <header className="sticky top-0 z-40 bg-white py-2 border-b">
      <div className="h-14 px-4 flex items-center justify-between">
        {/* Left: Brand Logo */}
        <div className="flex items-center">
          <img
            src={RushLogo}
            alt="Rush"
            className="h-6 w-auto object-contain"
          />
        </div>

        {/* Right: Notification Button */}
        <button
          type="button"
          className="
            h-9 w-9
            flex items-center justify-center
            rounded-full
            bg-gray-100
            text-gray-700
            hover:bg-gray-200
            transition
            focus:outline-none focus:ring-2 focus:ring-gray-300
          "
          aria-label="Notifications"
        >
          <Bell className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
};

export default TopNavBar;
